import React, { useRef, useState, useEffect } from "react";
import Tooltip from "../../UiLib/CustomTooltip/CustomTooltip";
import { Link } from "react-router-dom";
import { ITaskDisplay } from "../../../common/api_interfaces/task/ITaskDisplay.response";

interface TaskLinkProps {
    task: ITaskDisplay;
    url: string;
}

const TaskLink: React.FC<TaskLinkProps> = ({ task, url }) => {
    const containerRef = useRef<HTMLSpanElement | null>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (containerRef.current) {
            const containerWidth = containerRef.current.parentElement?.clientWidth;
            const textWidth = containerRef.current.offsetWidth;

            if (textWidth > containerWidth!) {
                setShowTooltip(true);
            } else {
                setShowTooltip(false);
            }
        }
    }, [task.name]);

    return (
        <>
            <Tooltip text={showTooltip ? task.name : ""} placement="bottom" offset={5}>
                <span ref={containerRef} className="task-name-new">
                    <Link to={url} style={{ textDecoration: "none", color: "inherit" }}>
                        {task.name}
                    </Link>
                </span>
            </Tooltip>
        </>
    );
};

export default TaskLink;
